module.exports = __webpack_public_path__ + "static/media/ProjectButton.38eca2b5.svg";